import { render, staticRenderFns } from "./RequestStatus.vue?vue&type=template&id=680c6e8b&scoped=true&"
import script from "./RequestStatus.vue?vue&type=script&lang=js&"
export * from "./RequestStatus.vue?vue&type=script&lang=js&"
import style0 from "./RequestStatus.vue?vue&type=style&index=0&id=680c6e8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c6e8b",
  null
  
)

export default component.exports